import { type ChainflipAsset } from '@chainflip/utils/chainflip';

export const PENDING_REDEMPTION = 'PENDING_REDEMPTION';
export const CHAINFLIP_SWAP_LIMITS = 'CHAINFLIP_SWAP_LIMITS';
export const CHAINFLIP_BLOCK_CONFIRMATIONS = 'CHAINFLIP_BLOCK_CONFIRMATIONS';
export const ACCOUNT_POOL_ORDERS = 'ACCOUNT_POOL_ORDERS';
export const CHAINFLIP_BOOST_LIQUIDITY = 'CHAINFLIP_BOOST_LIQUIDITY';

export const getAccountPoolOrderQueryKey = (
  baseAsset: ChainflipAsset,
  quoteAsset: ChainflipAsset,
  account: string,
) => [ACCOUNT_POOL_ORDERS, baseAsset, quoteAsset, account];

type ChainflipAccountId = `cF${string}`;

export const accountInfoRpcKey = (accountId: ChainflipAccountId | null | undefined) =>
  ['account_info', accountId] as const;
